// ./src/utils/api/SignupOrderService.ts
//
// ROADMAP A2h #151 — the HOST's side of a paid sign-up order (sign-up list items guests paid for online, #149): refunding
// it from Payments. Mirrors the ticket order refund (`EventTicketService.refundOrder`): any amount up to what is left,
// and the order's sign-ups are removed unless kept. The server decides everything else (who may, what is left, Stripe).
import { gql } from "@apollo/client";
import { OpResult } from "@sdflc/api-helpers";

import { ApiService } from "./ApiService";

export interface SignupOrderRefundInput {
  /** The paid sign-up order (a sign-up payment's `subjectId`). */
  orderId: string;
  /** How much; null = everything left. */
  amount?: number | null;
  /** Keep the order's sign-ups (money back, the guest still brings or gets them) instead of removing them. */
  keepSignups?: boolean;
  /** Record the refund without calling the processor (cash-back / offline). */
  bypassProcessor?: boolean;
  note?: string | null;
}

export interface SignupOrderRefund {
  orderId?: string | null;
  refundedAmount?: number | null;
  keptSignups?: boolean | null;
  bypassed?: boolean | null;
  processor?: string | null;
  processorRefundId?: string | null;
  paymentStatus?: string | null;
  removedSignupIds?: string[] | null;
}

const SIGNUP_ORDER_REFUND_MUTATION = gql`
  mutation SignupOrderRefund($params: SignupOrderRefundInput) {
    signupOrderRefund(params: $params) {
      code
      errors {
        name
        errors
      }
      data {
        orderId
        refundedAmount
        keptSignups
        bypassed
        processor
        processorRefundId
        paymentStatus
        removedSignupIds
      }
    }
  }
`;

export class SignupOrderService {
  /** Refund a paid sign-up order (executed on Stripe unless bypassed). Needs tickets.manage on the event. */
  static async refund(params: SignupOrderRefundInput): Promise<OpResult> {
    return ApiService.executeMutation(SIGNUP_ORDER_REFUND_MUTATION, { params });
  }
}
